import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-textarea',
  templateUrl: './textarea.component.html',
  styleUrls: ['./textarea.component.scss']
})
export class TextareaComponent {
  @Input() inputModel: string;
  @Input() label: string;
  @Input() placeholder: string;
  @Input() rows = 5;
  @Output() inputModelChange = new EventEmitter<string>();
}
